import { STORAGE_KEYS } from "../config";
import { logError } from "../services/logger";
export const setHighlightTipsActivity = (data) => {
    try {
        localStorage.setItem(STORAGE_KEYS.highlightTipsActivity, JSON.stringify(data));
    }
    catch (error) {
        logError({ error, message: "Couldn't grab tips activity" });
    }
};
export const getHighlightTipsActivity = () => {
    var _a;
    const data = (_a = localStorage.getItem(STORAGE_KEYS.highlightTipsActivity)) !== null && _a !== void 0 ? _a : "";
    return data ? JSON.parse(data) : [];
};
